import { createApp } from "vue";
import { createHead } from "@vueuse/head"; // 导入 createHead

import ElementPlus from "element-plus";
import "element-plus/es/components/message/style/css";
import "element-plus/es/components/message-box/style/css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/theme-chalk/dark/css-vars.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./styles/global.css";
import "./styles/element-plus.css";
import { isDarkMode, applyDarkMode } from "./utils/theme";

const app = createApp(App);
const head = createHead(); // 创建 head 对象

library.add(fas); // 引入所有 solid 图标
app.component("font-awesome-icon", FontAwesomeIcon);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 初始化壁纸
const initWallPapers = () => {
  if (typeof store.state.base.userConfig?.loginBkImg === "string") {
    store.commit("base/setWallPapers", { type: "loginBkImg", wallPapers: [] });
  }
  if (typeof store.state.base.userConfig?.adminLoginBkImg === "string") {
    store.commit("base/setWallPapers", { type: "adminLoginBkImg", wallPapers: [] });
  }
  if (typeof store.state.base.userConfig?.uploadBkImg === "string") {
    store.commit("base/setWallPapers", { type: "uploadBkImg", wallPapers: [] });
  }
};

// 获取用户配置后再挂载应用
store
  .dispatch("base/fetchUserConfig")
  .then(() => {
    document.title = store.state.base.userConfig?.siteTitle || "Jongsh Image Hosting = 穷拾の图床";

    store.subscribe((mutation, state) => {
      if (mutation.type === "base/setTheme") {
        applyDarkMode(isDarkMode(state.base.theme));
      }
    });

    applyDarkMode(isDarkMode(store.state.base.theme)); // 设置主题
    initWallPapers(); // 初始化壁纸

    app.use(store).use(router).use(ElementPlus).use(head).mount("#app");
  })
  .catch((error) => {
    console.error("Failed to load user configuration:", error);
    app.use(store).use(router).use(ElementPlus).use(head).mount("#app");
  });

// 设置 REM 适配
function setRem() {
  const width = document.documentElement.clientWidth;
  if (width < 768) {
    document.documentElement.style.fontSize = "14px";
  } else {
    document.documentElement.style.fontSize = "16px";
  }
}

setRem();
window.onresize = setRem; // 窗口大小改变时重新计算
